export const site = {
  name: 'K and son’s Guest House',
  logo: 'https://media-manager-c.questera.ai/greta-media/29d79c4109d1c19c2e75790b8e50872c9a33c9d5ce79f6f43f60effe48b91ada6d4fe9244bdd866a6b5eb503d1d2a9a7/images/aW1hZ2UvanBlZw==/659381171ae3c0dc0a8da58dcdd45a52.jpg',
  address: 'No. 20, A.K. Schnakenberg, Eththukala, Negombo.',
  phones: ['+94 74 144 0731', '+94 74 163 8458'],
  email: 'kandsons.com@gmail.com',
  whatsapp: 'https://wa.me/94741440731',
  welcome: 'Thank you for considering K and son’s Guest House. We look forward to welcoming you.',
  copyright: '© 2026 K and son’s Guest House. All rights reserved.',
  about: 'This inviting coastal retreat offers the ultimate balance of convenience and relaxation. Situated just 3.5 km from the bustling heart of Negombo and 15 km from Bandaranaike International Airport, the property ensures a seamless arrival and effortless exploration. Guests can enjoy being just a few steps from Negombo Beach and only 1.4 miles from Poruthota Beach, placing golden shores and local culture right at your doorstep.',
  images: {
    hero: 'https://cloud.sharemyimage.com/2026/10/06/1.-Hero.png',
    about: 'https://cloud.sharemyimage.com/2026/10/06/2.About.png',
    rooms: [
      'https://cloud.sharemyimage.com/2026/10/06/3.Room-card-1.png',
      'https://cloud.sharemyimage.com/2026/10/06/4.Room-card-2.png',
      'https://cloud.sharemyimage.com/2026/10/06/5.Room-card-3.png',
      'https://cloud.sharemyimage.com/2026/10/06/6.Room-card-4.png'
    ],
    gallery: [
      'https://cloud.sharemyimage.com/2026/10/06/7.Gallery-bedroom.png',
      'https://cloud.sharemyimage.com/2026/10/06/8.Gallery-lakeside.png',
      'https://cloud.sharemyimage.com/2026/10/06/9.Gallery-interior.png',
      'https://cloud.sharemyimage.com/2026/10/06/10.Gallery-dining.png',
      'https://cloud.sharemyimage.com/2026/10/06/11.Gallery-sunset-exterior.png'
    ]
  },
  galleryAlts: [
    'Bedroom prepared for a guest house stay',
    'Lakeside view near the guest house',
    'A considered interior detail',
    'Dining space at the guest house',
    'Guest house exterior at sunset'
  ],
  roomAlts: [
    'Guest room 1 interior',
    'Guest room 2 interior',
    'Guest room 3 interior',
    'Guest room 4 interior'
  ],
  nav: [
    { label: 'Home', to: '/' },
    { label: 'Our Rooms', to: '/rooms' },
    { label: 'About Us', to: '/about' },
    { label: 'Gallery', to: '/gallery' },
    { label: 'Contact', to: '/contact' }
  ],
  rooms: [1, 2, 3, 4].map((number) => ({
    number,
    title: number === 1 ? 'Skyscraper' : number === 2 ? 'Windmill' : `Room ${number} – [Add Name]`,
    image: `https://cloud.sharemyimage.com/2026/10/06/${number + 2}.Room-card-${number}.png`,
    images: [`https://cloud.sharemyimage.com/2026/10/06/${number + 2}.Room-card-${number}.png`],
    alt: `Guest room ${number} interior`,
    description: '[Add room description]',
    price: '[Add confirmed price]',
    capacity: '[Add confirmed capacity]',
    features: 'Wi-Fi · AC Rooms · Non-AC Rooms · Food · Hot Water · Parking'
  }))
};

export const amenities = [
  { icon: 'FiWifi', label: 'Wi-Fi' },
  { icon: 'FiWind', label: 'AC Rooms' },
  { icon: 'FiHome', label: 'Non-AC Rooms' },
  { icon: 'FiCoffee', label: 'Food' },
  { icon: 'FiDroplet', label: 'Hot Water' },
  { icon: 'FiTruck', label: 'Parking' }
];